export default "__VITE_ASSET__CiWKW57q__"